import { c as _c } from "react/compiler-runtime";
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { QAList, type Question } from '../_components/QAList';
const otherQuestions: Question[] = [{
  title: 'Gdzie mogę otrzymać bon za polecenie AlgoAcademy znajomemu?',
  content: <>
        Jeśli polecisz nas komuś, kto skorzysta z naszych usług, otrzymasz{' '}
        <span className='font-bold text-slate-700'>200 zł</span> do wykorzystania na dowolne usługi
        AlgoAcademy. Bez limitu poleceń.
      </>
}, {
  title: 'Czy organizujecie również warsztaty stacjonarne?',
  content: <>
        Tak, prowadzimy warsztaty stacjonarne dla naszych partnerów - szkół, uczelni, firm i innych
        placówek. Jeśli jesteś zainteresowany taką współpracą, przejdź na stronę{' '}
        <Link href='/partnerzy' className='font-bold text-algoprimary hover:underline'>
          partnerzy
        </Link>{' '}
        lub napisz do nas na{' '}
        <a href='mailto:kontakt@algoacademy.pl' className='font-bold text-algoprimary hover:underline'>
          kontakt@algoacademy.pl
        </a>
        .
      </>
}, {
  title: 'Jak mogę stać się nauczycielem lub mentorem w AlgoAcademy?',
  content: <>
        Zawsze szukamy pasjonatów informatyki, którzy chcą uczyć inaczej. Przejdź na stronę{' '}
        <Link href='/kariera' className='font-bold text-algoprimary hover:underline'>
          kariera
        </Link>{' '}
        lub napisz do nas na{' '}
        <a href='mailto:kontakt@algoacademy.pl' className='font-bold text-algoprimary hover:underline'>
          kontakt@algoacademy.pl
        </a>
        . Prowadzimy ciągły nabór.
      </>
}, {
  title: 'Czy AlgoAcademy udziela gwarancji za wyniki nauki?',
  content: <>
        Oferujemy gwarancję satysfakcji z naszych usług, ale nie możemy zagwarantować konkretnych
        wyników w nauce - to zależy głównie od Twojego zaangażowania i regularności.
      </>
}, {
  title: 'Czy AlgoAcademy odpowiada za problemy techniczne po stronie uczestników?',
  content: <>Niestety nie - za sprzęt i połączenie internetowe odpowiadasz we własnym zakresie.</>
}];
export function QAOtherSection() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <QAList questions={otherQuestions} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}